import { Type } from "@themes/pollinator/ui/Type";
import { type OrganizationActions } from "@core/features/actions";
import { OrgAdminActionList } from "../OrgAdminActionList";

export type Props = {
  organizationActionGroups: OrganizationActions[];
};

export function OrgAdminActionsSection({ organizationActionGroups }: Props) {
  if (organizationActionGroups.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6 w-full">
      <Type variant="h4">Organization Admin</Type>
      <div className="flex flex-col gap-6 w-full max-w-3xl">
        {organizationActionGroups.map((group) => (
          <OrgAdminActionList
            key={group.organizationId}
            actions={group.actions}
            organizationName={group.organizationName}
          />
        ))}
      </div>
    </div>
  );
}

export default OrgAdminActionsSection;
